// Chakra imports
import {
  Flex,
  SimpleGrid,
  Text,
  useColorModeValue,
  Box,
  Skeleton,
  SkeletonCircle,
  SkeletonText,
} from "@chakra-ui/react";
// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader";
// Custom icons
import {
  CartIcon,
  RocketIcon,
  StatsIcon,
  WalletIcon,
} from "components/Icons/Icons.js";
import React from "react";
import ChartStatistics from "./ChartStatistics";

const UserStats = ({ title, percentage, chart }) => {
  const iconBoxInside = useColorModeValue("white", "white");
  const textColor = useColorModeValue("gray.700", "white");
  return (
    <Card p="28px 10px 0px 0px" mb={{ sm: "26px", lg: "0px" }} >
      <CardHeader mb="20px" pl="22px">
        <Flex direction="column" alignSelf="flex-start">
          <Text fontSize="lg" color={textColor} fontWeight="bold" mb="6px">
            {title}
          </Text>
          <Text fontSize="md" fontWeight="medium" color="gray.400">
            <Skeleton height={"20px"} width={percentage ? null : "50%"} isLoaded={percentage || percentage == 0}>
              <Text
                as="span"
                color={percentage > 0 ? "green.400" : "red.500"}
                fontWeight="bold"
              >
                {percentage > 0 && "+"}
                {`${percentage}`}
              </Text>{" "}
              w porównaniu do ostatniego okresu
            </Skeleton>
          </Text>

        </Flex>
      </CardHeader>
      <Box mt={"auto"} w="100%" h={{ sm: "300px" }} ps="8px">
        <Skeleton height={percentage ? null : "95%"} isLoaded={percentage || percentage == 0}>
        {chart}
        </Skeleton>
      </Box>
    </Card>
  );
};

export default UserStats;
